// ES6 module syntax
import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
    en: {
        sidemenu: {
            accountStructure: 'Account Structure',
            organization: 'Organization',
            businessCase: 'Business Cases',
            reporting: 'Reporting',
            import: 'Import',
            export: 'Export',
            exportConfig: 'Export Config',
            logout: 'Logout',
            currency: 'Currency',
            allocations: 'Allocations',
            settings: 'Settings'
        },
        common: {
            balanceSheet: 'Balance Sheet',
            profitAndLoss: 'Profit & Loss',
            cashFlow: 'Cash Flow',
            assets: 'Assets',
            liabilities: 'Liabilities',
            equities: 'Equity',
            drivers: 'Drivers',
            favorites: 'Favorites',
            businessCases: 'Business Cases',
            reporting: 'Reporting',
            settings: 'Settings',
            import: 'Import',
            currency: 'Currency',
        },
        accountStructure: {
            selectRelatedAccount: 'Please select a Related Account',
            selectFavoriteAccount: 'Please select an Account',
            value: 'Value',
            formula: 'Formula',
            relatedAccount: 'Related Account',
            addSubConstraint: "Accounts with related account or formula can't have children.",
            addCustomConstraint: 'Accounts created in the custom view cannot create new sub accounts.',
            hasDependancies: 'Cannot delete this account because the following accounts are dependant:',
            carry: 'Carry values over periods',
            carryDependency:
                'This checkbox indicates whether this account should carry the value of the past period onward.',
            carryValueConstraint:
                'A related account cannot carry values. Assign value carrying in the original account.',
            pinNewAccount: 'Pin an account to favorites',
            nameCustomTab: 'Set tab name',
            converge: 'Converge',
            convergeDependancy:
                'This checkbox indicates that this value is part of a converge dependancy, an iterative algorithm will attempt to solve it.',
            exclude: 'Hide from business case',
            excludeDependancy:
                'This account will not appear in business case totals or reporting. The account is still calculated normally within each scenario.',
            accountManagement: 'Account Management',
            accountType: 'Account Type',
            accountNumber: 'Account Number:',
            accountNumberNotFound: 'Account Number Not Found',
            accountName: 'Account Name:',
            accountNameNotFound: 'Account Name Not Found',
            accountRollUp: 'Roll Up:',
            accountRollUpAdditive: 'Additive (default)',
            accountRollUpAdditiveTooltip: 'This checkbox sets the account as additive in the flow of calculations.',
            accountRollUpSubtractive: 'Subtractive',
            accountRollUpSubtractiveTooltip: 'This checkbox sets the account as subtractive in the flow of calculations.',
            accountRollUpIgnore: 'Ignore',
            accountRollUpIgnoreTooltip: 'This checkbox sets the account as ignored in the flow of calculations.',
            accountRollUpSubIgnoreTooltip:
                'Be Cautious! If you ignore the subaccount in the roll up and the subaccount has Change In accounts as children these Change In accounts will still have effect on P&L and/or Cash Flow.',
            accountEffect: 'Effect:',
            accountEffectCash: 'Cash (default)',
            accountEffectNonCash: 'Non Cash',
            accountAssociation: 'Association:',
            accountAssociationCreate: 'Create (default)',
            accountAssociationDoNotCreate: 'Do Not Create',
            accountExtra: 'Extra:',
            accountExtraCarry: 'Carry',
            accountExtraConverge: 'Converge',
            accountExtraExclude: 'Exclude from BC',
            accountCreateChangeIn: 'Create Change In',
            accountMainAccountNumber: 'Main Account Number:',
            accountMainAccountName: 'Main Account Name:',
            accountChangeInAccountNumber: 'Change In Account Number',
            accountChangeInAccountName: 'Change In Account Name',
            accountDelete:
                'Any of the formulas currently in the account structure does not get updated when deleting this account - make sure to update your formulas otherwise your scenarios will not compile',
            accountChooseSumType: 'Choose Account Sum Type',
            accountChooseSumNone: 'None:',
            accountChooseSumPeriod: 'Last period:',
            accountChooseSumPeriods: 'Sum periods:',
            accountChooseSumWeightedAvgNumber: 'Weight by fixed value:',
            accountChooseSumWeightedAvgAccount: 'Weight by account:',
            accountMetric: 'Change account metric:',
            accountMetricNumeric: 'Amount:',
            accountMetricRatio: 'Ratio:',
            accountMetricUnit: 'Unit:',
        },
        businessCase: {
            assemble: 'Assemble Business Case',
            create: 'Create a new Business Case',
            update: 'Update a Business Case',
            newName: 'New Business Case name',
        },
        settings: {
            globalSettings: 'Global Settings',
            periodManagement: 'Period Management',
            currency: 'Currency',
            amountsNotation: 'Amounts Notation',
            american: 'American',
            european: 'European',
            amountsSizing: 'Amounts Sizing',
            amountsDecimals: 'Amounts Decimals',
            units: 'Units',
            thousands: 'Thousands',
            hundredThousands: 'Hundreds of thousands',
            millions: 'Millions',
            startingYear: 'Starting Year',
            numPeriods: 'Number of periods',
            actuals: 'Actuals',
            actualsWarning:
                'Changing the amount of actual periods changes the total number of periods and can result in data loss - proceed with caution!',
            budget: 'Budget',
            budgetWarning:
                'Changing the amount of budget periods changes the total number of periods and can result in data loss - proceed with caution!',
            forecast: 'Forecast',
            forecastWarning:
                'Changing the amount of forecast periods changes the total number of periods and can result in data loss - proceed with caution!',
            budgetStarts: 'Budget starts',
            forecastStarts: 'Forecast starts',
            startMonthHint:
                'A year can be split between actuals, budget and forecast when it is shown by month (any month) or by quarter (start of a quarter). Changing the number of years resets the start month to January.',
            startMonthNeedsExpansion: 'Show this year by month or quarter in Expansion Management to start mid-year.',
            customPeriods: 'Periods',
            expansionManagement: 'Expansion Management',
            expansionManagementPeriod: 'Period',
            expansionManagementMonth: 'Month',
            expansionManagementQuarter: 'Quarter',
            expansionManagementCheckboxMonth: 'This checkbox sets the current periods to be expanded as months.',
            expansionManagementCheckboxQuarter: 'This checkbox sets the current periods to be expanded as quarters.',
        },
        organization: {
            currency: 'Currency',
            baseCurrency: 'Base Currency:',
            currencies: 'Currencies:',
        },
        export: {
            exportTemplateModal: 'Create New Template',
            templateName: 'New template name:',
            templateDescription: 'New template description:',
            editExportTemplateModal: '',
            includeBusinessCaseResult: 'Include result(s) from business case(s)',
            nonCalculatedValuesOnly: 'Include only non-calculated values',
        },
        scenario: {
            audit_trail: 'Audit Trail',
            create: 'Copy from another scenario or leave blank to create a new empty scenario',
        },
        allocations: {
            addAllocation: 'Add Allocation',
            editAllocation: 'Edit Allocation',
            from: 'From',
            to: 'To',
            businessCase: 'Business Case',
            entity: 'Entity',
            scenario: 'Scenario(s)',
            account: 'Account',
            period: 'Period',
            targetEntity: 'Target Entity',
            targetScenario: 'Target Scenario',
            targetAccount: 'Target Account',
        },
    },
    fr: {},
});

export default strings;
